import root from 'window-or-global';

class ScrollManager {
    subscribers = {};
    didInit = false;
    currentKey = 0;
    scrollY = 0;
    scrollX = 0;

    _init() {
        this.didInit = true;

        root.addEventListener('scroll', this._updateScroll);
        this._updateScroll();
    }

    _updateScroll = () => {
        this.scrollX = root.pageXOffset;
        this.scrollY = root.pageYOffset;
        this._publish();
    };

    _publish = () => {
        Object.keys(this.subscribers).forEach(key => {
            const callback = this.subscribers[key];
            callback(this.getProps());
        });
    };

    getProps = () =>
        this.didInit && {
            scrollX: this.scrollX,
            scrollY: this.scrollY
        };

    // This is only used for testing purposes
    _injectScrollTo = (scrollX, scrollY) => {
        this.scrollX = scrollX;
        this.scrollY = scrollY;
        this._publish();
    };

    subscribe = fn => {
        if (!this.didInit) this._init();

        fn(this.getProps());

        this.currentKey += 1;
        this.subscribers[this.currentKey] = fn;

        return this.currentKey;
    };

    unsubscribe = key => {
        delete this.subscribers[key];
    };
}

export default new ScrollManager();
